<template>
  <div class="navbar flex flex-col">
    <div
      class="flex content-wrapper justify-between align-center"
      style="flex-direction:row;z-index:1005"
    >
      <div class="logo">
        <img
          src="../../assets/img/whitelogo.png"
          alt="blinker logo"
          class="logo"
          @click="$router.push('/')"
        />
      </div>
      <div class="links flex align-center justify-between">
        <router-link to="/" class="link">Home</router-link>
        <router-link to="/findyourcar" class="link">Find your car</router-link>
        <a class="btn-contact" @click="notImplemented">Contact</a>
      </div>
      <PhoneMenu :bgColor="'#fff'" />
    </div>
    <div class="content-wrapper flex-col align-center" style="margin-top:40px;">
      <h1>Browse our cars</h1>
      <div class="input-wrap">
        <input
          @keydown.enter="filterBySearch"
          v-model="search"
          type="text"
          placeholder="Search by Make, Model or Keyword"
        />
        <div @click="filterBySearch" class="search-wrapper flex justify-center align-center">
          <font-awesome-icon icon="search" />
        </div>
      </div>
    </div>
    <div class="overlay"></div>
  </div>
</template>

<script>
import PhoneMenu from "../UI/phonemenu";
export default {
  props: ["reset"],
  data: () => ({
    search: "",
    typing: false
  }),
  components: { PhoneMenu },
  methods: {
    filterBySearch() {
      this.$emit("setSearch", this.search);
    },
    notImplemented() {
      alert("This feature has not been implemented.");
    }
  },
  watch: {
    reset() {
      if (this.reset) this.search = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.content-wrapper {
  align-items: center;
  flex-direction: column;
  margin-top: -20px;
  z-index: 2;
}
.navbar {
  height: 326px;
  padding: 40px 15px;
  background-color: grey;
  display: flex;
  align-items: center;
  position: relative;
}
.search-wrapper {
  position: absolute;
  cursor: pointer;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 10000;
  padding: 0 20px 0 8px;
  color: #6030b1;
  font-size: 32px;
  transition: all 200ms ease;
  &:hover {
    color: #ff328f;
  }
}
.overlay {
  background-image: url("../../assets/img/carpark.jpeg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(#29194741, 0.83);
    pointer-events: none;
  }
}
.input-wrap {
  width: 100%;
  max-width: 600px;
  position: relative;
  border-radius: 50px;
  overflow: hidden;
}
input {
  color: rgba(0, 0, 0, 0.87);
  width: 100%;
  max-width: 800px;
  height: 60px;
  font-size: 20px;
  padding-left: 20px;
  &:focus {
    outline: none !important;
  }
}

h1 {
  font-weight: 500;
  letter-spacing: 2px;
  text-align: center;
  letter-spacing: 0.1em;
  font-size: 45px;
  max-width: 1000px;
  margin-bottom: 40px;
  color: white;
}
.link {
  filter: brightness(0) invert(1);
}
.logo {
  transition: all 150ms ease;
  &:hover {
    filter: none;
  }
}
.links a.btn-contact {
  background-color: white;
  color: #6030b1 !important;
  &:hover {
    background-color: rgba(#ff328f, 1);
    color: white !important;
  }
}
#phone-nav {
  display: none;
}

@media screen and (max-width: 750px) {
  .links {
    display: none !important;
  }
  #phone-nav {
    display: block;
  }
}
@media screen and (max-width: 500px) {
  h1 {
    font-size: 31px;
  }
  input {
    font-size: 16px;
  }
}
@media screen and (max-width: 375px) {
  input {
    font-size: 14px;
  }
  .search-wrapper {
    font-size: 20px;
    padding: 0 10px 0 8px;
  }
}
</style>